<div *ngIf="condition" class="spinner-wrapper">
  <img src="assets/cs-loading.gif">
  <h4>{{message}}</h4>
</div>
